import { ComponentStylesWithFns } from '../../theme/styles.helpers';

export const ListCardStyles: ComponentStylesWithFns = {
  listCard: {
    backgroundColor: 'white',
    border: '1px solid #dce4ee',
    borderRadius: '12px',
    overflow: 'hidden',
    flexShrink: 0,
  },
  listCardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 14px',
    height: '46px',
    borderBottom: '1px solid #dce4ee',
  },
  listCardHeaderTitle: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#111',
  },
  countBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '21px',
    minWidth: '26px',
    backgroundColor: '#ebf2f6',
    border: '1px solid #dce4ee',
    borderRadius: '20px',
    padding: '0 8px',
    fontSize: '10px',
    fontWeight: 700,
    color: '#646e7d',
  },
  listCardBody: {
    padding: '14px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
};
